import React, {Component} from 'react'
import popup from '../../popup'
import { cancelSubscription } from '../../../../redux/user/helpers'

import './style.css'

class View extends Component {
  constructor(props) {
    super(props)

    this.cancelMySubscription = this.cancelMySubscription.bind(this)
  }

  cancelMySubscription() {
    cancelSubscription().then( popup.hide )
  }

  render() {
    return (
      <div className="cancel-subscription centered">
        <div className="header">
          <h1>Cancel Plan?</h1>
          <p>Are you sure you want to cancel your subscription plan?</p>
        </div>
        <div className="buttons">
          <div className="button outlined" onClick={ _ => { popup.hide() } }>No</div>
          <div className="button site-background-color" onClick={this.cancelMySubscription}>Yes</div>
        </div>
      </div>
    )
  }
}

export default View;
